// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntd[data-v-166dbfca] {\n  cursor: pointer;\n}\n.md2[data-v-166dbfca] {\n  max-width: none;\n}\nfieldset[data-v-166dbfca] {\n  max-width: 60%;\n  margin: auto;\n}\n", ""]);
// Exports
module.exports = exports;
